<template>
  <div class="column is-full">
    <div class="column is-full" v-if="isVisibleFromFilter">
      <header class="card-header">
        <p class="card-header-title">
          {{ reservation.location }}
          {{ reservation.hotel?.name }}
        </p>

        <p class="card-header-title is-justify-content-center">
          <i class="fa fa-person"></i>
          &nbsp; {{ $t("searchFilters.numberOfPersons") }}
          {{ reservation.numberOfGuests }}
        </p>

        <p class="card-header-title is-justify-content-flex-end">
          <span>
            <i class="fa fa-calendar"> </i>
            {{ formatDateLabel(reservation.startDate) }}
          </span>
        </p>
      </header>
      <div class="card-content">
        <table>
          <tbody>
            <tr>
              <th>{{ $t("meetingReservationOverview.hotel") }}</th>
              <td>
                {{
                  reservation.hotel
                    ? `${reservation.hotel.name}, ${reservation.hotel.street}`
                    : "-"
                }}
              </td>
            </tr>
            <tr>
              <th class="table-header">
                {{ $t("meetingReservationOverview.times") }}
              </th>
              <td>{{ reservation.startTime }} - {{ reservation.endTime }}</td>
            </tr>
            <tr>
              <th class="table-header">
                {{ $t("meetingReservationOverview.lunch") }}
              </th>
              <td>
                {{ reservation.needsLunch ? "✅" : "❌" }}
              </td>
            </tr>
            <tr>
              <th class="table-header">
                {{ $t("meetingReservationOverview.dinner") }}
              </th>
              <td>
                {{ reservation.needsDinner ? "✅" : "❌" }}
              </td>
            </tr>
            <tr>
              <th class="table-header">
                {{ $t("meetingReservationOverview.contactPerson") }}
              </th>
              <td>
                {{ reservation.contactName }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  isNowHappening,
  isFutureReservation,
  getDateRangeForReservation
} from "@/helpers/reservation.helper.js";

export default {
  props: {
    reservation: Object,
    visibleItems: {
      type: String,
      default: "ALL"
    }
  },
  computed: {
    isVisibleFromFilter() {
      let filter = this.visibleItems;
      switch (filter) {
        case "FUTURE":
          return isFutureReservation(this.reservation, "meeting");
        case "CURRENT":
          return isNowHappening(this.reservation, "meeting");
        default:
          return true;
      }
    },
    reservationDateRange() {
      return getDateRangeForReservation(this.reservation, "meeting");
    }
  }
};
</script>

<style scoped>
.table-header {
  padding-right: 10px;
}
</style>
